import { useCallback, useState } from 'react';

import { TRowModel } from '../types';

export const useRowExpansion = <Row extends TRowModel<Row>>(expandedIds: string[] | undefined) => {
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>(
    Object.fromEntries((expandedIds || []).map((currentString) => [currentString, true])) as Record<
      string,
      boolean
    >,
  );

  const setRowExpanded = useCallback(
    (rowKey: string, value: boolean) => {
      const updatedExpansions = { ...expandedRows };
      updatedExpansions[rowKey] = value;

      setExpandedRows(updatedExpansions);
    },
    [expandedRows],
  );

  const handleExpandedToggle = (rowKey: string) => {
    const currentValue = expandedRows[rowKey];
    setRowExpanded(rowKey, !currentValue);
  };

  return {
    expandedRows,
    setRowExpanded,
    handleExpandedToggle,
  };
};
